"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _myImages = _interopRequireDefault(require("./my-images"));

var _uploadTab = _interopRequireDefault(require("./upload-tab"));

var _myLogos = _interopRequireDefault(require("./my-logos"));

var _freeImages = _interopRequireDefault(require("./free-images"));

var _imageDetails = _interopRequireDefault(require("./image-details"));

var _wordpressImages = _interopRequireDefault(require("./wordpress-images"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _top = _interopRequireDefault(require("../controls/top"));

var _header = _interopRequireDefault(require("../controls/header"));

require("../lang");

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

var _reactDropzone = require("react-dropzone");

var _slideshow = require("./slideshow");

var _hooks = require("../hooks");

var _imageLibrary = require("../image-library");

var _notifications = _interopRequireDefault(require("../controls/notifications"));

var _templateObject, _templateObject2, _templateObject3;

var ContainerBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border: none;\n  outline: none;\n  &:active {\n    border: none;\n    outline: none;\n  }\n"])));

var OverlayBox = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n  top: 0;\n  z-index: 10;\n  opacity: 0;\n  pointer-events: none;\n  background: rgba(2, 136, 209, 0.6);\n  border: 2px solid $primitive-light-blue;\n  transition: opacity $default-animation-time ease-in-out;\n  ", "\n"])), function (props) {
  return props.dragging && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    opacity: 1;\n    transition: opacity $default-animation-time ease-in-out;\n  "])));
});

var ImageLibraryDesktop = function ImageLibraryDesktop() {
  var _React$useContext = _react["default"].useContext(_imageLibrary.ImageLibraryContext),
      topActions = _React$useContext.topActions,
      showLogosTab = _React$useContext.showLogosTab,
      logoMakerIntegrationUrl = _React$useContext.logoMakerIntegrationUrl;

  var _React$useState = _react["default"].useState([]),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      files = _React$useState2[0],
      setFiles = _React$useState2[1];

  var onDrop = _react["default"].useCallback(function (acceptedFiles) {
    setFiles(acceptedFiles);
  }, []);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      isDragActive = _useDropzone.isDragActive;

  var _useActiveView = (0, _hooks.useActiveView)(),
      currentView = _useActiveView.currentView,
      setCurrentView = _useActiveView.setCurrentView;

  _react["default"].useEffect(function () {
    if (isDragActive) {
      setCurrentView('upload', {
        returnPage: 'my-images'
      });
    }
  }, [isDragActive]);

  var getTitle = function getTitle(view) {
    switch (view) {
      case 'upload':
        return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
          message: "imagepicker.addImages"
        });

      case 'image-details':
        return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
          message: "imagepicker.imageDetails"
        });

      case 'slideshow':
        return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
          message: "imagepicker.selectImage"
        });

      default:
        return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
          message: "imagepicker.selectImage"
        });
    }
  };

  var marginTop = currentView === 'image-details' || currentView === 'upload' || currentView === 'slideshow' ? 63 : 115;
  return /*#__PURE__*/_react["default"].createElement(ContainerBox, getRootProps(), /*#__PURE__*/_react["default"].createElement(OverlayBox, {
    dragging: isDragActive
  }), /*#__PURE__*/_react["default"].createElement(_header["default"], {
    showClose: currentView === 'slideshow' || currentView !== 'image-details',
    showBackButton: currentView === 'upload' && currentView !== 'image-details' || currentView === 'slideshow' || currentView === 'image-details',
    title: getTitle(),
    showAddImageButton: currentView === 'my-images',
    actions: topActions
  }), /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Content, {
    hasNotificationBarContainer: false,
    contentSpacing: "none",
    marginTop: marginTop
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-content"
  }, currentView !== 'image-details' && currentView !== 'upload' && currentView !== 'slideshow' && /*#__PURE__*/_react["default"].createElement(_top["default"], {
    showLogosTab: showLogosTab
  }), /*#__PURE__*/_react["default"].createElement(_myImages["default"], null), /*#__PURE__*/_react["default"].createElement(_freeImages["default"], null), /*#__PURE__*/_react["default"].createElement(_myLogos["default"], {
    logoMakerIntegrationUrl: logoMakerIntegrationUrl,
    name: "my-logos"
  }), /*#__PURE__*/_react["default"].createElement(_uploadTab["default"], {
    initialFiles: files,
    isDragActive: isDragActive
  }), /*#__PURE__*/_react["default"].createElement(_imageDetails["default"], null), /*#__PURE__*/_react["default"].createElement(_wordpressImages["default"], null), /*#__PURE__*/_react["default"].createElement(_slideshow.WithContextSlideShow, null), /*#__PURE__*/_react["default"].createElement(_notifications["default"], null))));
};

var _default = ImageLibraryDesktop;
exports["default"] = _default;